"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useMemo } from "react";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { benefitsDefault } from "./benefits-data-eon";
import { FlipCard } from "./benefits-flipcard-eon";
import { BenefitSlider } from "./benefits-slider-eon";
export interface Benefit {
  icon: ReactNode | string;
  id: number;
  text: string;
  title: string;
}
export default function Benefits(_props) {
  const $ = _c(14);
  const t = useLanguage();
  let t0;
  if ($[0] !== t) {
    t0 = benefitsDefault(t);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const benefits = t0;
  let t1;
  if ($[2] !== t.jobad_benefits_headline) {
    t1 = <h2 className="mb-8 font-bold text-4xl text-foreground" data-source="lc">{t.jobad_benefits_headline}</h2>;
    $[2] = t.jobad_benefits_headline;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== benefits) {
    t2 = <div className="sm:hidden"><BenefitSlider benefits={benefits} /></div>;
    $[4] = benefits;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== benefits) {
    t3 = benefits.map(_temp);
    $[6] = benefits;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <ul className="hidden grid-flow-row auto-rows-fr grid-cols-2 gap-5 sm:grid lg:grid-cols-3 xl:gap-8">{t3}</ul>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <section className="outer-container py-container" id="benefits"><div className="inner-container grid gap-y-4">{t1}{t2}{t4}</div></section>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp(benefit) {
  return <FlipCard as="li" key={benefit.title} {...benefit} />;
}